import { type ReactNode, type Ref } from 'react';
import { Sheet, type SheetRef } from 'react-modal-sheet';
import { IconModelThumb } from '@/assets/svgs';
import {
	BOTTOM_MODAL_SHEET_THUMB_HEIGHT,
	BOTTOM_SHEET_TOP_MARGIN,
	NAVIGATION_HEIGHT,
} from '@/shared/consts/component.const';

type BottomSheetProps = {
	isOpen: boolean;
	snapPoint: number[];
	onSnapChange?: (index: number) => void;
	children?: ReactNode;
	ref?: Ref<SheetRef>;
};

const BottomSheet = ({
	isOpen,
	snapPoint,
	onSnapChange,
	children,
	ref,
}: BottomSheetProps) => {
	return (
		<Sheet
			isOpen={isOpen}
			ref={ref}
			onClose={() => {}}
			snapPoints={snapPoint}
			initialSnap={2}
			onSnap={onSnapChange}
			detent="full"
			disableDismiss
			disableScrollLocking
			style={{
				top: BOTTOM_SHEET_TOP_MARGIN,
				bottom: NAVIGATION_HEIGHT,
				zIndex: 20,
				left: '50%',
				right: 'auto',
				transform: 'translateX(-50%)',
				width: '100%',
				maxWidth: '28rem',
			}}
		>
			<Sheet.Container className="rounded-tl-4xl rounded-tr-4xl">
				<Sheet.Header
					className="shrink-0 rounded-tl-4xl rounded-tr-4xl bg-white"
					style={{ height: BOTTOM_MODAL_SHEET_THUMB_HEIGHT }}
				>
					<div className="flex h-full w-full items-center justify-center">
						<IconModelThumb />
					</div>
				</Sheet.Header>
				<Sheet.Content
					className="bg-white"
					scrollClassName="flex flex-col"
					disableScroll
				>
					{children}
				</Sheet.Content>
			</Sheet.Container>
		</Sheet>
	);
};

export default BottomSheet;
